import src from "IMAGE";
export default { src, width: 225, height: 225, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAASElEQVR42q3L2wqAMAwD0KVOUKnYgSmFgfv/v/QCgs+y8xQSktJPIjI+rvB2gEzzYiVqPVojqaoA7mHYLFvJuu5kRLj759fBCRE6Aq8LBZlxAAAAAElFTkSuQmCC", blurWidth: 8, blurHeight: 8 }
